module.exports = __webpack_public_path__ + "static/media/fondo.df980ff8.png";